import React from "react"
import { Col, Container, Row } from "react-bootstrap"

import DefaultLayout from "../../components/layout/DefaultLayout"
import StudentTable from "../../components/student/StudentTable"

const Student = () => {
  return (
    <DefaultLayout>
      <Container>
        <Row>
          <Col>
            <h1>Student</h1>

            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <StudentTable />
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  )
}

export default Student
